import i18next from 'i18next';

export const formatTrainingModuleLabel = (code, name) => {
  const trimmedCode = (code || '').trim();
  const title = name || '';
  if (!trimmedCode) {
    return title;
  }
  if (!title) {
    return trimmedCode;
  }
  return `${trimmedCode}. ${title}`;
};

export const formatTrainingMethodLabel = method =>
  method ? i18next.t(`trainingModules.tabs.${method}`, { defaultValue: method }) : '';

/**
 * Training part label: "{version} ({method})"
 * version is typically "year.revision", e.g. "2026.1 (Theory)"
 */
export const formatTrainingPartLabel = (version, method) => {
  const versionLabel = (version || '').toString().trim();
  const methodLabel = formatTrainingMethodLabel(method);
  if (!versionLabel) {
    return methodLabel;
  }
  if (!methodLabel) {
    return versionLabel;
  }
  return `${versionLabel} (${methodLabel})`;
};

export const buildTrainingPartVersionCode = (version, revision) => {
  if (version == null || version === '') {
    return '';
  }
  if (revision == null || revision === '') {
    return String(version);
  }
  return `${version}.${revision}`;
};
